export default __webpack_public_path__ + "static/media/11.285a3e2e.jpg";